import { Component, Input } from '@angular/core';

@Component({
  selector: 'craft-user-info-dropdown',
  templateUrl: './craft-user-info-dropdown.component.html',
  styleUrls: ['./craft-user-info-dropdown.component.scss'],
  standalone: false,
})
export class CraftUserInfoDropdownComponent {
  @Input() public user?: any;
  @Input() public disabled = false;
}
